document.addEventListener('DOMContentLoaded', function() {
  const swiperElement = document.querySelector('.featured-products-swiper');
  const slides = swiperElement ? swiperElement.querySelectorAll('.swiper-slide') : [];
  const hasMultipleSlides = slides.length > 1;
  
  const featuredProductsSwiper = new Swiper('.featured-products-swiper', {

    slidesPerView: 1.5,
    centerInsufficientSlides: true,
    centeredSlides: hasMultipleSlides,
    spaceBetween: -30,
    loop: false,
    watchOverflow: true,
    breakpoints: {
      768: {
        centeredSlides: false,
        slidesPerView: 3,
      }
    },
    
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  class FeaturedProductForm extends HTMLElement {
    constructor() {
      super();
      this.formId = this.getAttribute('data-form-id');
      this.productTitle = this.getAttribute('data-product-title');
      this.companyId = this.getAttribute('data-company-id');
      this.formSubmitted = false;
      this.inputsAlreadySet = new Set(); // Track which inputs we've already set
      this.formEvents = []; // Track form events for this instance
      this.submittedProducts = []; // Store submitted products as an instance variable
      
      // Create content
      this.innerHTML = `
        <div class="featured-product-modal__klaviyo-form">
          <div class="klaviyo-form-${this.formId}"></div>
        </div>
      `;
      
      // Load Klaviyo if not loaded
      this.loadKlaviyo();
      
      // Load stored submissions and set instance variable
      this.loadStoredSubmissions();
      
      // Monitor Klaviyo form events
      this.monitorKlaviyoEvents();
      
      // Check submission status and update UI
      // this.checkSubmissionStatus();
      
      // Set up mutation observer to detect form changes
      this.setupFormObserver();
    }
    
    loadKlaviyo() {
      if (!window.klaviyo && this.companyId) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js';
        document.head.appendChild(script);
        
        const formScript = document.createElement('script');
        formScript.async = true;
        formScript.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${this.companyId}`;
        document.head.appendChild(formScript);
      }
    }
    
    monitorKlaviyoEvents() {
      // Use a bound function to maintain 'this' context
      this.klaviyoEventHandler = this.handleKlaviyoEvent.bind(this);
      window.addEventListener('klaviyoForms', this.klaviyoEventHandler);
      
      // console.log(`Monitoring Klaviyo form events for: ${this.formId}`);
    }
    
    handleKlaviyoEvent(e) {
      const detail = e.detail;
      const eventType = detail.type;
      const formId = detail.formId;
      
      // Only process events for this specific form
      if (formId !== this.formId) return;
      
      // Record the event
      this.formEvents.push({
        type: eventType,
        timestamp: new Date().toISOString(),
        details: detail
      });
      
      // console.log(`Klaviyo form event for ${this.productTitle}: ${eventType}`, detail);
      
      switch(eventType) {
        case 'submit':
          // console.log(`Form submitted for product: ${this.productTitle}`);
          this.handleFormSubmission();
          break;
          
        case 'open':
        case 'embedOpen':
          // console.log(`Form opened for product: ${this.productTitle}`);
          break;
          
        case 'close':
          // console.log(`Form closed for product: ${this.productTitle}`);
          break;
      }
    }
    
    disconnectedCallback() {
      // Clean up event listener when element is removed
      if (this.klaviyoEventHandler) {
        window.removeEventListener('klaviyoForms', this.klaviyoEventHandler);
        // console.log(`Stopped monitoring Klaviyo events for: ${this.formId}`);
      }
    }
    
    loadStoredSubmissions() {
      // Get submissions from localStorage and store as instance variable
      const storedData = localStorage.getItem('featuredProductSubmissions');
      
      if (storedData) {
        try {
          const parsedSubmissions = JSON.parse(storedData);
          this.submittedProducts = Array.isArray(parsedSubmissions) ? parsedSubmissions : [];
          // console.log('Loaded stored submissions:', this.submittedProducts);
        } catch (e) {
          console.error('Error parsing stored submissions:', e);
          this.submittedProducts = [];
        }
      } else {
        this.submittedProducts = [];
      }
      
      // Make the submissions available globally for other components
      if (!window.featuredProductsSubmissions) {
        window.featuredProductsSubmissions = this.submittedProducts;
      }
    }
    
    checkSubmissionStatus() {
      // Check if this product form was submitted before
      if (this.submittedProducts.includes(this.productTitle)) {
        console.log('showThankYouMessage() in checkSubmissionStatus()');
        this.showThankYouMessage();
      } else if (this.submittedProducts.length > 0) {
        console.log('showLimitMessage() in checkSubmissionStatus()');
        this.showLimitMessage();
      }
    }
    
    setupFormObserver() {
      // Watch for form changes
      const observer = new MutationObserver((mutations) => {
        // Check for success message first - higher priority
        const successFound = this.checkForSuccessMessage(mutations);
        if (successFound) return;
        
        // Only then check for inputs to populate
        this.checkForDynamicInputs(mutations);
      });
      
      // Start observing this component
      observer.observe(this, { childList: true, subtree: true });
    }
    
    checkForSuccessMessage(mutations) {
      for (const mutation of mutations) {
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
        
        // Look for the form submission success message
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1 || !node.querySelector) continue;
          
          const heading = node.querySelector('h1');
          if (heading && heading.textContent.includes('Submission Success')) {
            console.log('Submission Success, now handling form submission');
            this.handleFormSubmission();
            return true;
          }
        }
      }
      return false;
    }
    
    checkForDynamicInputs(mutations) {
      for (const mutation of mutations) {
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
        
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          
          // Check if node is or contains our target input
          let inputs = [];
          
          if (node.tagName === 'INPUT' && node.placeholder === 'Product Selection Dynamic') {
            inputs = [node];
          } else if (node.querySelectorAll) {
            inputs = Array.from(node.querySelectorAll('input[placeholder="Product Selection Dynamic"]'));
          }
          
          // Set values for any new inputs we haven't processed yet
          inputs.forEach(input => {
            // Use the input's unique position in DOM as identifier
            const inputId = this.getUniqueInputId(input);
            
            if (!this.inputsAlreadySet.has(inputId)) {
              this.setProductSelectionValue(input);
              this.inputsAlreadySet.add(inputId);
            }
          });
        }
      }
    }
    
    getUniqueInputId(input) {
      // Generate a unique identifier for the input based on its position in the DOM
      const path = [];
      let element = input;
      
      while (element && element !== this) {
        let index = 0;
        let sibling = element;
        while (sibling.previousElementSibling) {
          sibling = sibling.previousElementSibling;
          index++;
        }
        
        const tag = element.tagName.toLowerCase();
        path.unshift(`${tag}:${index}`);
        element = element.parentElement;
      }
      
      return path.join(' > ');
    }
    
    setProductSelectionValue(input) {
      input.value = this.productTitle;
      
      // Trigger input and change events
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
      
      const changeEvent = new Event('change', { bubbles: true });
      input.dispatchEvent(changeEvent);
      
      // console.log(`Set product input to: ${this.productTitle}`);
    }
    
    handleFormSubmission() {
      this.formSubmitted = true;

      console.log('recordSubmission() in handleFormSubmission()');
      this.recordSubmission();
      console.log('showThankYouMessage() in handleFormSubmission()');
      this.showThankYouMessage();
      
      
      setTimeout(() => {
        const modal = this.closest('details');
        if (modal && modal.hasAttribute('open')) {
          modal.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
        }
      }, 20000);
    }
    
    recordSubmission() {
      if (!this.submittedProducts.includes(this.productTitle)) {
        this.submittedProducts.push(this.productTitle);
        // localStorage.setItem('featuredProductSubmissions', JSON.stringify(this.submittedProducts));
        // console.log(`Recorded submission for: ${this.productTitle}`);
        // console.log('Updated submissions:', this.submittedProducts);
        
        // Update global reference
        window.featuredProductsSubmissions = this.submittedProducts;
      }
    }
    
    showThankYouMessage() {
      this.innerHTML = `
        <div class="featured-product-modal__thank-you">
          <h3>Thank you for your submission!</h3>
          <p>We've received your information.</p>
          <p>If selected, you'll receive an email from concierge@piggybanxinc.com, by end of the day.</p>
          <p>Please be sure to check your junk/spam folders.</p>
        </div>
      `;
    }
    
    showLimitMessage() {
      this.innerHTML = `
        <div class="featured-product-modal__limit-message">
          <h3>Limited to one submission</h3>
          <p>You've already submitted a form for another product.</p>
        </div>
      `;
    }
  }
  
  if (!customElements.get('featured-product-form')) {
    customElements.define('featured-product-form', FeaturedProductForm);
  }

  class AvailableProductForm extends HTMLElement {
    constructor() {
      super();
      
      this.variantId = this.getAttribute('data-product');
      this.productTitle = this.getAttribute('data-product-title');
      
      // create button if it doesn't exist
      if (!this.querySelector('button')) {
        this.innerHTML = `
          <button type="button" class="add-to-cart-button">
            <span>Add to Cart</span>
          </button>
        `;
      }
      
      const addToCartButton = this.querySelector('button');
      if (addToCartButton) {
        addToCartButton.addEventListener('click', this.addToCart.bind(this));
      }
    }
    
    addToCart(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const formData = {
        'items': [{
          'id': this.variantId,
          'quantity': 1
        }]
      };
      
      // loading state
      const button = event.currentTarget;
      button.classList.add('loading');
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // console.log('Added to cart:', data);
        button.classList.remove('loading');
        button.classList.add('added');
        button.querySelector('span').textContent = 'Added!';
        
        setTimeout(() => {
          button.classList.remove('added');
          button.querySelector('span').textContent = 'Add to Cart';
        }, 2000);
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => {
        console.error('Error:', error);
        button.classList.remove('loading');
        button.classList.add('error');
        button.querySelector('span').textContent = 'Error';
        
        setTimeout(() => {
          button.classList.remove('error');
          button.querySelector('span').textContent = 'Add to Cart';
        }, 2000);
      });
    }
  }
  
  if (!customElements.get('available-product-form')) {
    // customElements.define('available-product-form', AvailableProductForm);
  }
  
  // submissions from localStorage available globally
  let submittedProducts = [];
  try {
    const storedData = localStorage.getItem('featuredProductSubmissions');
    if (storedData) {
      submittedProducts = JSON.parse(storedData) || [];
    }
  } catch (e) {
    console.error('Error loading stored submissions:', e);
  }
  
  //submissions available globally
  window.featuredProductsSubmissions = submittedProducts;
  
  const productCards = document.querySelectorAll('.featured-product-card[data-modal-trigger]');
  
  // Store swiper instance for reference
  let featuredSwiper = null;
  if (document.querySelector('.featured-products-swiper')) {
    featuredSwiper = document.querySelector('.featured-products-swiper').swiper;
  }
  
  productCards.forEach((card) => {
    const modal = card.closest('[product-card]').querySelector('details-modal details');
    const productTitle = modal.querySelector('summary').getAttribute('data-selected-product');
    
    card.addEventListener('click', function(e) {
      e.preventDefault();
      
      
      // Get latest submissions (they might have been updated)
      const currentSubmissions = window.featuredProductsSubmissions || [];
      
      if (modal && !modal.hasAttribute('open')) {
        modal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        
        // Check submission status and update modal content if needed
        /*
        const modalForm = modal.querySelector('.featured-product-modal__form');
        if (modalForm) {
          if (currentSubmissions.includes(productTitle)) {
            // product was already submitted
            console.log('showThankYouMessage() in productCards.forEach()');
            modalForm.innerHTML = `
              <div class="featured-product-modal__thank-you">
                <h3>Thank you for your submission!</h3>
                <p>We've received your information.</p>
                <p>If selected, you'll receive an email from concierge@piggybanxinc.com.</p>
                <p>Please be sure to check your junk/spam folders.</p>
              </div>
            `;
          } else if (currentSubmissions.length > 0) {
            // other product was submitted - show limit message
            console.log('showLimitMessage() in productCards.forEach()');
            modalForm.innerHTML = `
              <div class="featured-product-modal__limit-message">
                <h3>Limited to one submission</h3>
                <p>You've already submitted a form for another product.</p>
              </div>
            `;
          } else {
            // No submissions yet - recalculate Klaviyo form if needed
            if (window.klaviyo) {
              window.klaviyo.recalculate();
            }
          }
        }
        */
      }
    });
    
    const closeButton = modal.querySelector('.featured-product-modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (modal && modal.hasAttribute('open')) {
          modal.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
          
          // Resume swiper autoplay if it was running
          if (featuredSwiper && featuredSwiper.autoplay) {
            featuredSwiper.autoplay.start();
          }
        }
      });
    }
    
    modal.addEventListener('click', function(e) {
      if (e.target === this || e.target.classList.contains('featured-product-modal__content')) {
        if (modal.hasAttribute('open')) {
          modal.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
          
          // Resume swiper autoplay if it was running
          if (featuredSwiper && featuredSwiper.autoplay) {
            featuredSwiper.autoplay.start();
          }
        }
      }
    });
  });
});
